import { getTenantStorageKey } from "@/lib/tenant"

function tokenKey(): string {
  return getTenantStorageKey("token")
}

export const TOKEN_KEY = "token"

export const getToken = () => sessionStorage.getItem(tokenKey())

export const setToken = (value: string) =>
  sessionStorage.setItem(tokenKey(), value)

export const removeToken = () => sessionStorage.removeItem(tokenKey())
